import {getInjection} from '@runlab/di'

export const getClient = (target?: 'api' | 'web-api') => {
  const factory = getInjection('IApiClientServiceFactory')

  return factory(target)
}
